import { render } from "./SelectGender.vue?vue&type=template&id=76bba485&ts=true"
import script from "./SelectGender.vue?vue&type=script&lang=ts"
export * from "./SelectGender.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__